import {connectRouter} from 'connected-react-router'
import {history} from './history'

type History = typeof history

const createRouterReducer = (history: History) => connectRouter(history)

export const routerReducer = createRouterReducer